import { baseRoutes } from '../../core/config/routes';

export const routes = {
  ...baseRoutes,
  admin: {
    ...baseRoutes.admin,
    employees: {
      employee: '/admin/employees/employee',
      list: '/admin/employees',
      new: '/admin/employees/new',
      edit: '/admin/employees/:id',
    },
    vehicles: {
      list: '/admin/vehicles',
      new: '/admin/vehicles/new',
      edit: '/admin/vehicles/:id',
    },
    clients: {
      list: '/admin/clients',
      new: '/admin/clients/new',
      newClientVehicle: '/admin/clients/:id/new',
      edit: '/admin/clients/:id',
      editClientVehicle: '/admin/clients/client-vehicle/:id',
    },
    clientVehicles: {
      list: '/admin/client-vehicles',
      new: '/admin/client-vehicles/new',
      edit: '/admin/client-vehicles/:id',
    },
    timeOffs: {
      list: '/admin/time-offs',
      employeeList: '/admin/time-offs/employee',
    },
    items: {
      list: '/admin/items',
    },
    orders: {
      list: '/admin/orders',
      new: '/admin/orders/new',
      edit: '/admin/orders/:id',
      overview: '/admin/overview',
    },
    commercialOffers: {
      list: '/admin/commercial-offers',
      new: '/admin/commercial-offers/new',
      edit: '/admin/commercial-offers/:id',
      overview: '/admin/overview',
    },
    invoices: {
      list: '/admin/invoices',
      edit: '/admin/invoices/:id',
    },
    tasks: {
      schedule: '/admin/tasks',
      employeeSchedule: '/admin/tasks/employee-schedule',
    },
    expenses: {
      list: '/admin/expenses',
      new: '/admin/expenses/new',
      edit: '/admin/expenses/:id',
    },
  },
  auth: {
    ...baseRoutes.auth,
  },
  public: {
    commercialOfferConfirm: 'commercial-offer-confirm/:token',
  },
};
